import PropTypes from '../_util/vue-types';
import KEYCODE from './KeyCode';
import { computed, defineComponent, ref, withDirectives } from 'vue';
import antInput from '../_util/antInputDirective';
export default defineComponent({
    props: {
        disabled: { type: Boolean, default: undefined },
        changeSize: Function,
        quickGo: Function,
        current: Number,
        locale: PropTypes.object,
        rootPrefixCls: String,
        goButton: PropTypes.any,
    },
    setup(props) {
        const goInputText = ref('');
        const validValue = computed(() => {
            return !goInputText.value || isNaN(goInputText.value)
                ? undefined
                : Number(goInputText.value);
        });
        const handleChange = e => {
            const { value, composing } = e.target;
            if (e.isComposing || composing || goInputText.value === value)
                return;
            goInputText.value = value;
        };
        const handleBlur = e => {
            const { goButton, quickGo, rootPrefixCls } = props;
            if (goButton || goInputText.value === '') {
                return;
            }
            if (e.relatedTarget &&
                (e.relatedTarget.className.indexOf(`${rootPrefixCls}-item-link`) >= 0 ||
                    e.relatedTarget.className.indexOf(`${rootPrefixCls}-item`) >= 0)) {
                goInputText.value = '';
                return;
            }
            else {
                quickGo(validValue.value);
                goInputText.value = '';
            }
        };
        const go = e => {
            if (goInputText.value === '') {
                return;
            }
            if (e.keyCode === KEYCODE.ENTER || e.type === 'click') {
                // https://github.com/vueComponent/ant-v3-nancal/issues/1316
                props.quickGo(validValue.value);
                goInputText.value = '';
            }
        };
        return () => {
            const { rootPrefixCls, locale, changeSize, quickGo, goButton, disabled, } = props;
            const prefixCls = `${rootPrefixCls}-options`;
            let goInput = null;
            let gotoButton = null;
            if (!changeSize && !quickGo) {
                return null;
            }
            if (quickGo) {
                if (goButton) {
                    gotoButton =
                        typeof goButton === 'boolean' ? (<button type="button" onClick={go} onKeyup={go} disabled={disabled} class={`${prefixCls}-quick-jumper-button`}>
                {locale.jump_to_confirm}
              </button>) : (<span onClick={go} onKeyup={go}>
                {goButton}
              </span>);
                }
                goInput = (<div class={`${prefixCls}-quick-jumper`}>
            {locale.jump_to}
            {withDirectives(<input disabled={disabled} type="text" value={goInputText.value} onInput={handleChange} onChange={handleChange} onKeyup={go} onBlur={handleBlur}/>, [[antInput]])}
            {locale.page}
            {gotoButton}
          </div>);
            }
            return (<li class={`${prefixCls}`}>
          {goInput}
        </li>);
        };
    },
});
